"use client";

import React from "react";
import { DefaultTheme, useTheme } from "styled-components";
import { SpaceThemeNames } from "../models";

const retiredThemeNameMap = {
  pismo: SpaceThemeNames.wyman,
  dockweiler: SpaceThemeNames.scher,
};

export default function useSpaceThemeName(): SpaceThemeNames {
  const theme: DefaultTheme = useTheme();
  const themeName = React.useMemo(() => {
    if (retiredThemeNameMap[theme?.themeName]) return retiredThemeNameMap[theme?.themeName];
    return theme?.themeName || SpaceThemeNames.classic;
  }, [theme]);
  return themeName;
}
